export const queryParams = (params = {}) => {
  const esc = encodeURIComponent;
  return Object.keys(params)
    .map(k => {
      return `${esc(k)}=${esc(params[k])}`;
    })
    .join('&');
};
